






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { Tooltip } from 'element-ui';

@Component({
  name: 'lb-tooltip'
  // components: {
  //   'el-tooltip': Tooltip
  // }
})
export default class extends Vue {
  @Prop({ default: 0 }) private openDelay!: number;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop({ type: Boolean, default: false }) private manual!: boolean;
  @Prop({ default: 'dark' }) private effect!: string;
  @Prop({ default: 0 }) private offset!: number;
  @Prop() private content!: string;
  @Prop({ type: Boolean, default: true }) private visibleArrow!: boolean;
  @Prop({ default: 'top' }) private placement!: string;
  @Prop({ default: 'el-fade-in-linear' }) private transition!: string;
  @Prop({
    default() {
      return {
        boundariesPadding: 10,
        gpuAcceleration: false,
      };
    },
  }) private popperOptions!: object;
  @Prop({ type: Boolean, default: true }) private enterable!: boolean;
  @Prop({ default: 0 }) private hideAfter!: number;
  @Prop({ default: 0 }) private tabindex!: number;
}
